import type { SVGProps } from 'react';

/**
 * Gem-cut diamond icon for the Fan tier — ported from PopshopRN
 * subscription-level-icons (Fan). Uses `currentColor` so the
 * parent controls the fill via text color.
 */
export function FanIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg viewBox="0 0 16 17" fill="none" aria-hidden {...props}>
      <path
        d="M15.375 6.67063L11.875 2.67062C11.8282 2.61718 11.7706 2.57431 11.7059 2.54489C11.6412 2.51547 11.571 2.50017 11.5 2.5H4.5C4.42896 2.50017 4.35877 2.51547 4.29411 2.54489C4.22945 2.57431 4.1718 2.61718 4.125 2.67062L0.625003 6.67063C0.543351 6.76385 0.499229 6.88407 0.501192 7.00798C0.503155 7.13189 0.551064 7.25066 0.635628 7.34125L7.63563 14.8413C7.68241 14.8914 7.73901 14.9314 7.80191 14.9587C7.86481 14.9861 7.93267 15.0002 8.00125 15.0002C8.06984 15.0002 8.13769 14.9861 8.20059 14.9587C8.26349 14.9314 8.32009 14.8914 8.36688 14.8413L15.3669 7.34125C15.4511 7.25035 15.4986 7.13141 15.5001 7.0075C15.5016 6.88359 15.457 6.76354 15.375 6.67063ZM13.8981 6.5H11.25L9 3.5H11.2731L13.8981 6.5ZM4.66125 7.5L6.54438 12.2081L2.15063 7.5H4.66125ZM11.3388 7.5H13.8494L9.45563 12.2081L11.3388 7.5ZM4.72688 3.5H7L4.75 6.5H2.10188L4.72688 3.5Z"
        fill="currentColor"
      />
    </svg>
  );
}
